// extracted by mini-css-extract-plugin
module.exports = {"content":"product-details-accordion_content___2Htk","strong":"product-details-accordion_strong__mnp0_"};